var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4258 7.91016L20.2734 6.15234L18.5156 0H6.21094C4.75471 0 3.57422 1.18049 3.57422 2.63672V27.3633C3.57422 28.8195 4.75471 30 6.21094 30H23.7891C25.2453 30 26.4258 28.8195 26.4258 27.3633V7.91016Z",
    fill: "#4086F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4258 7.91016V27.3633C26.4258 28.8195 25.2453 30 23.7891 30H15V0H18.5156L20.2734 6.15234L26.4258 7.91016Z",
    fill: "#4175DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4258 7.91016H20.2734C19.3066 7.91016 18.5156 7.11914 18.5156 6.15234V0C18.7441 0 18.9727 0.0878906 19.1308 0.26373L26.1621 7.29498C26.3379 7.45312 26.4258 7.68164 26.4258 7.91016Z",
    fill: "#80AEF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2734 14.1211H9.72656C9.24076 14.1211 8.84766 13.728 8.84766 13.2422C8.84766 12.7564 9.24076 12.3633 9.72656 12.3633H20.2734C20.7592 12.3633 21.1523 12.7564 21.1523 13.2422C21.1523 13.728 20.7592 14.1211 20.2734 14.1211Z",
    fill: "#FFF5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2734 17.6367H9.72656C9.24076 17.6367 8.84766 17.2436 8.84766 16.7578C8.84766 16.272 9.24076 15.8789 9.72656 15.8789H20.2734C20.7592 15.8789 21.1523 16.272 21.1523 16.7578C21.1523 17.2436 20.7592 17.6367 20.2734 17.6367Z",
    fill: "#FFF5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2734 21.1523H9.72656C9.24076 21.1523 8.84766 20.7592 8.84766 20.2734C8.84766 19.7876 9.24076 19.3945 9.72656 19.3945H20.2734C20.7592 19.3945 21.1523 19.7876 21.1523 20.2734C21.1523 20.7592 20.7592 21.1523 20.2734 21.1523Z",
    fill: "#FFF5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7578 24.668H9.72656C9.24076 24.668 8.84766 24.2749 8.84766 23.7891C8.84766 23.3033 9.24076 22.9102 9.72656 22.9102H16.7578C17.2436 22.9102 17.6367 23.3033 17.6367 23.7891C17.6367 24.2749 17.2436 24.668 16.7578 24.668Z",
    fill: "#FFF5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.668H16.7578C17.2436 24.668 17.6367 24.2749 17.6367 23.7891C17.6367 23.3033 17.2436 22.9102 16.7578 22.9102H15V24.668Z",
    fill: "#E3E7EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.1523H20.2734C20.7592 21.1523 21.1523 20.7592 21.1523 20.2734C21.1523 19.7876 20.7592 19.3945 20.2734 19.3945H15V21.1523Z",
    fill: "#E3E7EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.6367H20.2734C20.7592 17.6367 21.1523 17.2436 21.1523 16.7578C21.1523 16.272 20.7592 15.8789 20.2734 15.8789H15V17.6367Z",
    fill: "#E3E7EA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.1211H20.2734C20.7592 14.1211 21.1523 13.728 21.1523 13.2422C21.1523 12.7564 20.7592 12.3633 20.2734 12.3633H15V14.1211Z",
    fill: "#E3E7EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.42082789c4b8361cc1119cef53efb6bf.svg";
export { ForwardRef as ReactComponent };